// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { Action } from "redux"
import { catchError, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { RECENT_TAGS_ORDER_BY_KEY } from "."
import { ofType } from "redux-observable"

export type StorageReader = () => Observable<number>

export const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(RECENT_TAGS_ORDER_BY_KEY)
    if (data !== null) {
      // convert to number for matching index from RecentOrderBy enum
      return of(Number(data))
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const loadRecentOrderBy = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      ofType(Actions.loadRecentOrderByFromStorage),
      mergeMap(_ => load().pipe(
        map(Slice.setRecentOrderBy),
        catchError(_ => of(Actions.loadRecentOrderByFromStorageFailed())),
      )),
    )

export default loadRecentOrderBy(load)

